import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RestrictionWarnSheetComponent } from '@sc/ui-components';
import {
  RestrictionWarnInputData,
  RestrictionWarnOutputData,
} from '@sc/data-access-models';

@Component({
  selector: 'sc-restriction-warn-dialog',
  styleUrls: ['./restriction-warn-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [RestrictionWarnSheetComponent],
  template: `
    <sc-restriction-warn-sheet
      [restrictionInfos]="data.restrictionInfos"
      [licensePlate]="data.licensePlate"
      (redirectEvent)="onRedirect($event)"
      (cancelEvent)="onCancel()"
    ></sc-restriction-warn-sheet>
  `,
})
export class RestrictionWarnDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: RestrictionWarnInputData,
    private readonly dialogRef: MatDialogRef<
      RestrictionWarnDialogComponent,
      RestrictionWarnOutputData
    >
  ) {}

  onRedirect(redirectUri: string) {
    this.dialogRef.close({ type: 'contact', redirectUri });
  }

  onCancel() {
    this.dialogRef.close({ type: 'cancel' });
  }
}
